/*
 * @Description: 认证
 * @Date: 2024-12-12 11:39:23
 */

import { route } from './src/router/index';

const name = 'test';

export { name, route };
